<script>
    import { push } from "svelte-spa-router";
    import {data} from "../store";
    import {fade} from 'svelte/transition';
    import {onMount} from 'svelte';
    let etapa=0;
    let respuestaA,respuestaB,respuestaC;
    let fecha = new Date();
    let documento = {
        nombre: "Covid",
        fecha: fecha,
        texto:[
            "",
            "¿PADECE ALGUN SÍNTOMA CORPORAL COMPATIBLE A COVID-19? (FALTA DE AIRE, CANSANCIO, MALESTAR GENERAL, FIEBRE MAYOR A 38 GRADOS, DISMINUCIÓN DEL GUSTO Y OLFATO, TOS SECA, ENTRE OTROS)",
            "",
            "¿ESTUVO EN CONTACTO ESTRECHO CON UNA PERSONA POSITIVO EN COVID-19?",
            ""
        ]
    }
    onMount(()=>{
        if ($data.local == undefined || $data.local == ""){
            push('/');
        }
    })
    function siguiente(pregunta,respuesta){
        etapa++;
        if (pregunta == 0){
            switch(respuesta){
                case 0:
                    documento.texto[4] = "NO TUVE NI TENGO NINGUN SÍNTOMA/S DESCRIPTOS ANTERIORMENTE";
                    break;
                case 1:
                    documento.texto[4] = "TUVE SÍNTOMAS O CONTRAJE COVID-19, PERO YA NO LOS PADEZCO";
                    break;
                case 2:
                    documento.texto[4] = "TENGO UNO O VARIOS SÍNTOMAS DESCRIPTOS ANTERIORMENTE";
                    break;
                case 3:
                    documento.texto[4] = "ESTOY EMPEZANDO A TENER UNO O VARIOS SÍNTOMAS DESCRIPTOS ANTERIORMENTE";
                    break;
            }
        }
        if (pregunta == 1){
            switch(respuesta){
                case 0:
                    documento.texto[6] = "NO ESTUVE CON NINGUNA PERSONA INFECTADA";
                    break;
                case 1:
                    documento.texto[6] = "ESTUVE CON UNA PERSONA INFECTADA, YA RECUPERADA";
                    break;
                case 2:
                    documento.texto[6] = "ESTUVE CON UNA PERSONA INFECTADA, AÚN NO RECUPERADA";
                    break;
                case 3:
                    documento.texto[6] = "ESTUVE CON UNA PERSONA INFECTADA, PERO MI HISOPADO DIO NEGATIVO";
                    break;
            }
        }
        if (etapa>1){
            $data.respuestas.push(documento);
            push("/servicio");
        }
    }
</script>
<div class="flex flex-col items-center justify-start w-full h-full p-4" in:fade="{{duration: 500}}">
    <div class="w-full grid grid-cols-4 grid-row-auto">
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-white shadow rounded-full flex items-center justify-center">1</div>
        </div>
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-red-500 shadow rounded-full text-white flex items-center justify-center">2</div>
        </div>
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-white shadow rounded-full flex items-center justify-center">3</div>
        </div>
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-white shadow rounded-full flex items-center justify-center">4</div>
        </div>
    </div>
    <div class="w-full grid grid-cols-4 grid-row-auto text-xs text-center">
        <div class="flex flex-col items-center justify-start">
            Datos Personales
        </div>
        <div class="flex flex-col items-center justify-start">
            Preguntas Covid
        </div>
        <div class="flex flex-col items-center justify-start">
            Servicio
        </div>
        <div class="flex flex-col items-center justify-start">
            Firma
        </div>
    </div>
    <div class="w-full flex flex-col items-center justify-start pt-8">
        {#if etapa == 0}
            <p class="w-full text-center text-xl font-bold mb-2" >¿PADECE ALGUN SÍNTOMA CORPORAL COMPATIBLE A COVID-19? (FALTA DE AIRE, CANSANCIO, MALESTAR GENERAL, FIEBRE MAYOR A 38 GRADOS, DISMINUCIÓN DEL GUSTO Y OLFATO, TOS SECA, ENTRE OTROS)</p>
            <div on:click={()=>siguiente(1,0)} class="mb-4 p-2 text-center rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">
                NO TUVE NI TENGO NINGUN SÍNTOMA/S DESCRIPTOS ANTERIORMENTE
            </div>
            <div on:click={()=>siguiente(1,1)} class="mb-4 p-2 text-center rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">
                TUVE SÍNTOMAS O CONTRAJE COVID-19, PERO YA NO LOS PADEZCO
            </div>
            <div on:click={()=>siguiente(1,2)} class="mb-4 p-2 text-center rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">
                TENGO UNO O VARIOS SÍNTOMAS DESCRIPTOS ANTERIORMENTE
            </div>
            <div on:click={()=>siguiente(1,3)} class="mb-4 p-2 text-center rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">
                ESTOY EMPEZANDO A TENER UNO O VARIOS SÍNTOMAS DESCRIPTOS ANTERIORMENTE
            </div>
        {:else if etapa == 1}
            <p class="w-full text-center text-xl font-bold mb-2" >¿ESTUVO EN CONTACTO ESTRECHO CON UNA PERSONA POSITIVO EN COVID-19?</p>
            <div on:click={()=>siguiente(2,0)} class="mb-4 p-2 text-center rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">
                NO ESTUVE CON NINGUNA PERSONA INFECTADA
            </div>
            <div on:click={()=>siguiente(2,1)} class="mb-4 p-2 text-center rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">
                ESTUVE CON UNA PERSONA INFECTADA, YA RECUPERADA
            </div>
            <div on:click={()=>siguiente(2,2)} class="mb-4 p-2 text-center rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">
                ESTUVE CON UNA PERSONA INFECTADA, AÚN NO RECUPERADA
            </div>
            <div on:click={()=>siguiente(2,3)} class="mb-4 p-2 text-center rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">
                ESTUVE CON UNA PERSONA INFECTADA, PERO MI HISOPADO DIO NEGATIVO
            </div>
        {/if}
    </div>
</div>